module.exports = __webpack_public_path__ + "img/common_avater.bfaa8823.jpg";